import ShortPreloader from './ShortPreloader';

export default ShortPreloader;
